import React from 'react';

import { CmTh, CmTooltip, QuestionIcon } from '@/components/uiParts';

type Props = {
  label: string;
  question?: string;
};

export const CmThWithQuestionIcon: React.FC<Props> = ({
  label,
  question,
  ...rest
}) => {
  return (
    <CmTh
      top="0"
      padding="10px"
      textAlign="center"
      {...rest}
      style={{ textTransform: 'none' }}
    >
      {label}
      {question && (
        <CmTooltip label={question}>
          <QuestionIcon
            color="gray"
            size="sm"
            verticalAlign="text-top"
            marginLeft="2px"
            fontSize="small"
          />
        </CmTooltip>
      )}
    </CmTh>
  );
};
